import log from 'loglevel';
import { caseDefaultDetails, countryCode } from '../../App/App.config';
import { router } from '../../services'
import pushGTMEvent from '../../util/helper/pushGTMEvent';
import { isEmpty } from '../../util/util';

const getHULA = async (langStrings, user, hulaDetails, dispatch, credentials) => {
  const { selectedProductVersion  } = hulaDetails;
  const product = selectedProductVersion.slice(0, selectedProductVersion.length - 5) // return product
  const release = selectedProductVersion.slice(product.length + 1, selectedProductVersion.length) // return year
  
  let productKey;
  if(!isEmpty(hulaDetails.productKey)) {
    productKey = hulaDetails.productKey;
  } else if(Object.keys(hulaDetails.productKeyMapping).length !== 0){
    const { productKeyMapping } = hulaDetails;
    if(productKeyMapping.length > 0) {
      productKeyMapping.forEach(data => {
        let { productLineName } = data;
        productLineName = productLineName.replace('Autodesk ', '');
        if(productLineName === product && data.productKey && data.release === release) {
          productKey = data.productKey;
        }
      })
    }
  } else if(hulaDetails.productVersionKeys){
    // e.g. "Advance Steel 2019" -> "Advance Steel_2019"
    if(!isEmpty(hulaDetails.productVersionKeys.productKey)) {
      productKey = hulaDetails.productVersionKeys.productKey[release];
    }
    if(!isEmpty(hulaDetails.productVersionKeys[product])){
      productKey = hulaDetails.productVersionKeys[product][release]; 
    }
  } else {
    productKey = "empty"
  }

  const payload = {
    serialNumber: hulaDetails.serialNumber,
    authEmail: hulaDetails.authEmail || user.email,
    productKey,
    requestType: "Y",
    requester: {
      country: countryCode,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
    },
    case: {
      ...caseDefaultDetails,
      requestedProductYear: release,
    },
  };

  try {
    // loading spinner.
    dispatch({ type: 'GO_TO_SPIN_PAGE' });
    const hulaResponse = await router(
      'HULA',
      payload,
      credentials,
    );
    if(hulaResponse.status === 200) {
      // SUCCESS
      pushGTMEvent('Success');
      log.debug('API response status 200 and value : ', hulaResponse);
      
      // dispatch({ type: 'UPDATE_SUCCESS' });
      return dispatch({ type: 'GO_TO_SUCCESS_PAGE', payload: { hulaResponse, productKey } });
    } if(hulaResponse.status === 400){
      log.debug('API RESPONSE ERROR 400', hulaResponse);
      const errorString = `Error/${ hulaResponse.errors[0].code}`;
      pushGTMEvent(errorString);
      let errorDesc;
      let errorMessage;
      switch(hulaResponse.errors[0].code) {
        case 'HL-15':
        case 'HL-03':
          // HL-15 and HL-03 are same! 
          errorDesc = hulaResponse.errors[0].detail;
          errorMessage = langStrings.errors.invalidSerialNumber
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage,
              },
            });
          log.debug('HULA HL-03 Error');
          dispatch({ type: 'INVLID_SERIAL_NUMBER' });
          return dispatch({ type: 'GO_TO_PRODUCT_INFO_PAGE' });  
        case 'HL-04': 
          errorDesc = hulaResponse.errors[0].detail;
          errorMessage = langStrings.requestFailedScreen.inactiveSubsTitle;
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage,
              },
            });
          log.debug('HULA HL-04 Error');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'HL04' });
        case 'HL-17':  
        case 'HL-06': 
          errorDesc = hulaResponse.errors[0].detail;
          errorMessage = langStrings.requestFailedScreen.prodNotEligibleTitle;
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage,
              },
            });
          log.debug('HULA HL-06 Error');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'HL06' });
        case 'HL-07': 
          errorDesc = hulaResponse.errors[0].detail;
          errorMessage = langStrings.requestFailedScreen.pageTitle2;
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc,
              errorMessage,
              },
            });
          log.debug('HULA HL-07 Error');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'HL07' });  
        case 'HL-10':
          errorMessage =  hulaDetails.isUserAdmin ? 
            langStrings.errors.notCMSC : langStrings.errors.enterCMSCEmail;
          dispatch({
            type: 'UPDATE_HULA_ERROR',
            payload: {
              errorDesc: errorMessage,
            }});
          log.debug('HULA HL-10 Error');
          dispatch({ type: 'EXPAND_FOOTER_ON_ERROR'});
          return dispatch({ type: 'GO_TO_AUTHORIZE_PAGE'});
        default:
          errorDesc = `Generic Error\nAPIGEE Code: ${hulaResponse.errors[0].code}\nAPIGEE Details: ${hulaResponse.errors[0].detail}`;
          errorMessage = 'Generic Error'; 
          log.debug('Generic Error');
          return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' }); 
      }
    } else {
      log.debug('No case faound!');
      return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' }); 
    }
  } catch (hulaError) {
    log.debug('Error : ', hulaError);
    return dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
  }
};

export default getHULA;
